import React from "react"

const Spacer = () => {
  return <div className="h-6" />
}

export default Spacer
